import { PButton, PInlineNotification } from "@porsche-design-system/components-react"
import { FormattedMessage, useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import type { ColorPickerFieldProps, ColorRadioButtonGroupProps, InputFieldProps } from "src/components"
import { ButtonGroup, FormLayout, ColorPickerField, ColorRadioGroupField, InputField } from "src/components"
import { messages } from "../useCustomRoofColor"

export interface CustomRoofColorProps {
	hasSubmitFailed: boolean
	hexCode: ColorPickerFieldProps
	isSubmitting: boolean
	name: InputFieldProps[]
	setHasSubmitFailed: (value: boolean) => void
	showCatalogRoofColorContainer: () => void
	tag: ColorRadioButtonGroupProps
}

export const CustomRoofColor = ({
	hasSubmitFailed,
	hexCode,
	isSubmitting,
	name,
	setHasSubmitFailed,
	showCatalogRoofColorContainer,
	tag,
}: CustomRoofColorProps) => {
	const { formatMessage } = useIntl()
	return (
		<>
			<FormLayout>
				{name.map((props, index) => (
					<InputField key={index} {...props} />
				))}
				<ColorRadioGroupField {...tag} />
				<ColorPickerField {...hexCode} />
				{hasSubmitFailed && (
					<PInlineNotification
						state="error"
						description={formatMessage(formMessages.errorGeneral)}
						onDismiss={() => setHasSubmitFailed(false)}
					/>
				)}
			</FormLayout>

			<ButtonGroup>
				<PButton loading={isSubmitting}>
					<FormattedMessage {...formMessages.save} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={showCatalogRoofColorContainer}>
					<FormattedMessage {...messages.selectCatalogRoofColor} />
				</PButton>
			</ButtonGroup>
		</>
	)
}
